import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  google2fa_status: 0,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload;
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
  },
});

export default userSlice.reducer;

export const { setToken, setUser } = userSlice.actions;
